/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The synchronisation status of the platform catalog.
 */
export type PlatformCatalogSynchronisationStatus =
  (typeof PlatformCatalogSynchronisationStatus)[keyof typeof PlatformCatalogSynchronisationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformCatalogSynchronisationStatus = {
  UNSYNCHRONISED: "UNSYNCHRONISED",
  SYNCHRONISED: "SYNCHRONISED",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  MISMATCHED_RULES: "MISMATCHED_RULES",
} as const;
